import gql from 'graphql-tag';

export default gql`
  query AllProperties($searchTerm: String, $filterTerm: [PropertyType!]) {
    properties(
      orderBy: updatedAt_DESC
      where: {
        OR: [
          { type_in: $filterTerm }
          { address_contains: $searchTerm }
          { code_contains: $searchTerm }
          { salesAgent_contains: $searchTerm }
          { code_contains: $searchTerm }
          { suburb_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      address
      size
      valuation
      suburb
      rooms
      erfNumber
      status
      salesAgent
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/AllProperties.ts